module.exports = __webpack_public_path__ + "static/media/Payment.17631611.svg";